module.exports = __webpack_public_path__ + "static/img/score-mobile-2.ad7281fe.png";